module.exports = __webpack_public_path__ + "img/placeholder.9c7d1f34.png";